import { Link } from "react-router-dom";
import CarpetGuideSkeleton from "./skeletons/CarpetGuideSkeleton";
import { getListingUrl } from "../../../../../utils/url.utils";

export default function CarpetGuide({
    title,
    guides = [],
    activeId,
    activeData,
    onChange,
    loading,
}) {
    if (!guides.length) return null;

    return (
        <section className="carpet-guide-container">
            <h2 className="guide-title">{title}</h2>

            <div className="tab-scroll-wrapper">
                <div className="tab-container">
                    {guides.map((item) => (
                        <button
                            key={item.id}
                            disabled={loading}
                            className={`tab-btn ${activeId === item.id ? "active" : ""}`}
                            onClick={() => onChange(item.id)}
                        >
                            {item.name.split(" ")[0].toUpperCase()}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <CarpetGuideSkeleton />
            ) : (
                activeData && (
                    <div className="guide-content">
                        <div className="guide-image">
                            <img src={activeData.media} alt={activeData.name} />
                        </div>

                        <div className="guide-info">
                            <h3>{activeData.name}</h3>
                            <p className="guide-desc">{activeData.short_description}</p>

                            <table className="conversion-table">
                                <thead>
                                    <tr>
                                        <th colSpan="3">Conversion Chart</th>
                                    </tr>
                                    <tr>
                                        <th>Size in Cm</th>
                                        <th>Size in Ft.</th>
                                        {/* <th>Recommended For</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {activeData.size_guide_sizes?.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.size_in_cm}</td>
                                            <td>{row.size_in_feet}</td>
                                            {/* <td>{row.recommended || "-"}</td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <Link to={getListingUrl(activeData.action_url)}>
                                <button className="shop-btn">
                                    {activeData.button_styles}
                                </button>
                            </Link>
                        </div>
                    </div>
                )
            )
            }
        </section >
    );
}
